export default "__VITE_ASSET__RSNUYOER__"